import React from 'react'
import Forstartupshero from '../components/forstartupshero/forstartupshero'
import Expertise from '../components/expertise/expertise'
import Specially from '../components/specially/specially'
import Engagement from '../components/engagementmodels/engagement'
import Talktous from '../components/talktous/talktous'
import Connectwithus from '../components/connectwithus/connectwithus'
import Footer from '../components/footer/footer'
import Startupservices from '../components/startupservices/startupservices'
import Features from '../components/startupfeatures/startupfeatures'




function forstartups() {
    return (
        <div>
            <Forstartupshero/>
            <Startupservices defaultTab={1}/>
            <Features/>
            <Expertise />
            <Specially />
            <Engagement />
            <Talktous />
            <Connectwithus />
            <Footer />
        </div>

    )
}

export default forstartups